import Vue from 'vue'
import Clipboard from 'clipboard'
import { Message } from 'element-ui'

export const clipboardSuccess = () =>
  Vue.prototype.$message({
    message: 'Copy successfully',
    type: 'success',
    duration: 2000
  })

export const clipboardError = () =>
  Vue.prototype.$message({
    message: 'Copy failed',
    type: 'error'
  })

export const handleClipboard = (text: string, event: MouseEvent) => {
  const clipboard = new Clipboard(event.target as Element, {
    text: () => text
  })
  clipboard.on('success', () => {
    clipboardSuccess()
    clipboard.destroy()
  })
  clipboard.on('error', () => {
    clipboardError()
    clipboard.destroy()
  })
  ;(clipboard as any).onClick(event)
}

// 复制图片到粘贴板
export const copyImgs = async (url: string) => {
  var canvas = document.createElement('canvas') // 创建一个画板
  let image = new Image()
  image.setAttribute('crossOrigin', 'Anonymous') //可能会有跨越问题
  image.src = url
  image.onload = () => {
    // img加载完成事件
    let canvasInfo: any = canvas
    canvasInfo.width = image.width //设置画板宽度
    canvasInfo.height = image.height //设置画板高度
    canvasInfo.getContext('2d').drawImage(image, 0, 0) //加载img到画板
    let url = canvasInfo.toDataURL('image/png') // 转换图片为dataURL，格式为png
    clipboardImg(url)
  }
}

export const clipboardImg = async (url: string) => {
  try {
    const response = await fetch(url)
    const blob = await response.blob()
    let navigatorObj: any = navigator.clipboard
    await navigatorObj.write([new window.ClipboardItem({ [blob.type]: blob })])
    Message({
      message: 'Copy successfully',
      type: 'success'
    })
  } catch (error) {
    Message({
      message: 'The image format is incorrect, please confirm the image format',
      type: 'success'
    })
  }
}
